import axios, { AxiosPromise } from 'axios';

export const loadTipoCadastro = (): AxiosPromise<any> =>
  axios.get(`/api/tipos-cadastros`);
